import { RemoteActivateInactivatePerson } from 'data/usecases';
import { ActivateInactivatePersonUseCaseInterface } from 'domain/usecases';
import { makeApiUrlPerson } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteActivateInactivatePerson =
  (): ActivateInactivatePersonUseCaseInterface =>
    new RemoteActivateInactivatePerson(
      makeApiUrlPerson(),
      makeAxiosHttpClient(),
    );
